import React, { useMemo, useEffect, useRef } from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { NavItem } from 'tbk-components/src/components/Nav';
import FooterTop, { IFooterTopProps } from './FooterTop';
import FooterCalloutNavigation, {
	IFooterCalloutNavigationProps,
} from './FooterCalloutNavigation';
import FooterMenu, { IFooterMenuProps } from './FooterMenu';
import FooterBottom, {
	IFooterBottomProps,
} from './FooterBottom';

// Represents a link in the language selector drop-down
export type LanguageNavItem = {
	href: string;
	label: string;
	target?: string;
	icon?: string;
	code?: string;
	locale?: string;
};

export interface IFooterProps extends IBaseElementProps {
	footerTopProps?: IFooterTopProps;
	footerTopNav?: NavItem[];
	footerCalloutNavigationProps?: IFooterCalloutNavigationProps;
	footerMenuProps?: IFooterMenuProps;
	footerBottomProps?: IFooterBottomProps;
}

const Footer: React.FC<IFooterProps> = ({
	className,
	classNames = [],
	footerTopProps,
	footerCalloutNavigationProps,
	footerMenuProps,
	footerBottomProps,
}) => (
	<footer className={className || cn('calian-footer', ...classNames)}>
		<div className="calian-footer__container container-fluid">
			{footerTopProps && <FooterTop {...footerTopProps} />}
			{footerCalloutNavigationProps &&
				footerCalloutNavigationProps.calloutNavigation &&
				footerCalloutNavigationProps.calloutNavigation.length > 0 && (
					<FooterCalloutNavigation
						{...footerCalloutNavigationProps}
					/>
				)}
			{footerMenuProps &&
				footerMenuProps.footerMenu &&
				footerMenuProps.footerMenu.length > 0 && (
					<FooterMenu {...footerMenuProps} />
				)}
			{footerBottomProps && <FooterBottom {...footerBottomProps} />}
		</div>
	</footer>
);

export default Footer;
